import React from "react";
import { Box, Typography, Button, Container } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { saveAuth } from "../globals/authentication";
import { getMappedRole } from "../globals/utils";

const InternalLoginSubHeader = ({ auth }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const username = auth?.user?.username || "";
  const role = getMappedRole(auth?.role);

  const authBackup = JSON.parse(localStorage.getItem("auth_backup"));
  const previousUsername = authBackup?.user?.username || "";

  const handleLogout = () => {
    localStorage.removeItem("auth");
    if (authBackup) {
      saveAuth(authBackup);
      localStorage.removeItem("auth_backup");
    }

    const auth = encodeURIComponent(JSON.stringify(authBackup));

    // Redirect to internal login
    navigate(`/login-internal/?authDetails=${auth}`, { replace: true });
  };

  return (
    <Container maxWidth="xs" disableGutters>
      <Box
        sx={{
          px: 4,
          py: 1.5,
          backgroundColor: "#2f7431",
          color: "white",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box>
          <Typography variant="subtitle1">
            {previousUsername}-{t("Logged in as")}:
          </Typography>
          <Typography
            variant="body2"
            sx={{
              mt: 0.5,
              fontSize: "0.9rem",
            }}
          >
            {role} : {username}
          </Typography>
        </Box>

        <Button
          onClick={handleLogout}
          endIcon={<CloseIcon />}
          sx={{
            color: "white",
            textTransform: "none",
            fontWeight: 500,
            fontSize: "0.875rem",
            px: 2,
            py: 1,
            borderRadius: 2,
            border: "1px solid rgba(255, 255, 255, 0.2)",
          }}
        >
          Logout
        </Button>
      </Box>
    </Container>
  );
};

export default InternalLoginSubHeader;
